import { useMediaQuery } from "react-responsive";

export function useDeviceType() {
  const isDesktop = useMediaQuery({ query: "(min-width: 1824px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1823px)" });

  return { isDesktop, isLaptop };
}
